/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface SuiviActionEditDto
 */
export interface SuiviActionEditDto {
    /**
     * 
     * @type {number}
     * @memberof SuiviActionEditDto
     */
    idsuiviAction?: number;
    /**
     * 
     * @type {number}
     * @memberof SuiviActionEditDto
     */
    idsuivi?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof SuiviActionEditDto
     */
    dateEcheance?: Date;
    /**
     * 
     * @type {number}
     * @memberof SuiviActionEditDto
     */
    idtypeSuiviAction?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviActionEditDto
     */
    idcollaborateur?: number;
    /**
     * 
     * @type {Date}
     * @memberof SuiviActionEditDto
     */
    dateRealisation?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviActionEditDto
     */
    remarque?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviActionEditDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {FileUploadDto}
     * @memberof SuiviActionEditDto
     */
    fichier?: FileUploadDto;
    /**
     * 
     * @type {Date}
     * @memberof SuiviActionEditDto
     */
    reassignmentDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviActionEditDto
     */
    reassignmentUser?: number | null;
}

/**
 * Check if a given object implements the SuiviActionEditDto interface.
 */
export function instanceOfSuiviActionEditDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuiviActionEditDtoFromJSON(json: any): SuiviActionEditDto {
    return SuiviActionEditDtoFromJSONTyped(json, false);
}

export function SuiviActionEditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuiviActionEditDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsuiviAction': !exists(json, 'idsuiviAction') ? undefined : json['idsuiviAction'],
        'idsuivi': !exists(json, 'idsuivi') ? undefined : json['idsuivi'],
        'dateEcheance': !exists(json, 'dateEcheance') ? undefined : (new Date(json['dateEcheance'])),
        'idtypeSuiviAction': !exists(json, 'idtypeSuiviAction') ? undefined : json['idtypeSuiviAction'],
        'idcollaborateur': !exists(json, 'idcollaborateur') ? undefined : json['idcollaborateur'],
        'dateRealisation': !exists(json, 'dateRealisation') ? undefined : (json['dateRealisation'] === null ? null : new Date(json['dateRealisation'])),
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fichier': !exists(json, 'fichier') ? undefined : FileUploadDtoFromJSON(json['fichier']),
        'reassignmentDate': !exists(json, 'reassignmentDate') ? undefined : (json['reassignmentDate'] === null ? null : new Date(json['reassignmentDate'])),
        'reassignmentUser': !exists(json, 'reassignmentUser') ? undefined : json['reassignmentUser'],
    };
}

export function SuiviActionEditDtoToJSON(value?: SuiviActionEditDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsuiviAction': value.idsuiviAction,
        'idsuivi': value.idsuivi,
        'dateEcheance': value.dateEcheance === undefined ? undefined : (value.dateEcheance.toISOString()),
        'idtypeSuiviAction': value.idtypeSuiviAction,
        'idcollaborateur': value.idcollaborateur,
        'dateRealisation': value.dateRealisation === undefined ? undefined : (value.dateRealisation === null ? null : value.dateRealisation.toISOString()),
        'remarque': value.remarque,
        'idfichier': value.idfichier,
        'fichier': FileUploadDtoToJSON(value.fichier),
        'reassignmentDate': value.reassignmentDate === undefined ? undefined : (value.reassignmentDate === null ? null : value.reassignmentDate.toISOString()),
        'reassignmentUser': value.reassignmentUser,
    };
}

